/** Validate form **/

// Own e-mail validation (via CheckEmail() in PHP)
$.validator.addMethod('customemail', function (value, element) {
    return eval($.ajax({
        url: strPath + 'components/check-email.php',
        type: 'POST',
        async: false,
        data: {txtEmail: value}
    }).responseText);

}, 'Please enter a valid e-mail');

// Unsubscribe
function FormValidateUnsubscribe(objForm) {
    var validator = $(objForm).validate(
        {
            rules: {
                // Check if e-mail exists in database
                txtEmail: {
                    remote: {
                        url: strAjaxPath + 'validate/unsubscribe.php',
                        type: 'post'
                    }
                }
            },
            messages: {
                txtEmail: {
                    required: strLabelGiveEmail,
                    customemail: strLabelEmailInvalid
                }
            }
        });

    return validator;
}

// Login
function FormValidateLogin(objForm, strTypeLogin) {
    var validator = $(objForm).validate(
        {
            messages: {
                txtUsername: {
                    required: strLabelGiveEmail,
                    customemail: strLabelEmailInvalid
                },
                txtPassword: {
                    required: strLabelGivePassword
                }
            },
            submitHandler: function () {
                // Check if combination username and password exists (don't check in validator, problem with errors)
                $.post(strAjaxPath + 'validate/login.php', 'txtUsername=' + $('input#txtUsername').val() + '&txtPassword=' + $('input#txtPassword').val(), function (strData) {
                    // Remove previous errors
                    $('input#txtUsername').removeClass('error');
                    $('input#txtPassword').removeClass('error');
                    $('input#txtPassword').parent().find('label.error').remove();

                    if (strData !== true) {
                        // Show error
                        $('input#txtUsername').addClass('error');
                        $('input#txtPassword').addClass('error');
                        $('input#txtPassword').after($('<label id="txtPassword" class="error" for="txtPassword">' + strData + '</label>'));
                    } else {
                        if (strTypeLogin == 'loginpopup') {
                            // Login (in popup) after adding giftcard code
                            $.post(strAjaxPath + 'validate/giftcard-after-login.php', '', function (strData) {
                                parent.location.reload();
                            });
                        } else {
                            // Correct => submit form
                            objForm.unbind('submit');
                            objForm.submit();
                        }
                    }
                }, 'json');
            }
        });

    return validator;
}

// Forgot password
function FormValidateForgotPassword(objForm) {
    var validator = $(objForm).validate(
        {
            rules: {
                // Check if e-mail exists and has a password
                txtEmail: {
                    remote: {
                        url: strAjaxPath + 'validate/forgot-password.php',
                        type: 'post'
                    }
                }
            },
            // Error has to be shown after the button
            errorPlacement: function (error, element) {
                if (element.attr('name') == 'txtEmail') {
                    error.addClass('ml-2 w-a');
                    error.insertAfter('#btnSubmit');
                } else {
                    error.insertAfter(element);
                }
            },
            messages: {
                txtEmail: {
                    required: strLabelGiveEmail,
                    customemail: strLabelEmailInvalid
                }
            }
        });

    return validator;
}


// Forgot password reset
function FormValidateForgotPasswordReset(objForm) {
    var validator = $(objForm).validate(
        {
            rules: {
                // Check if password is valid
                txtPassword: {
                    remote: {
                        url: strAjaxPath + 'validate/forgot-password-reset.php',
                        type: 'post'
                    }
                },
                txtPasswordConfirm: {
                    equalTo: '#txtPassword'
                }
            },
            messages: {
                txtPassword: {
                    required: strLabelGivePassword
                },
                txtPasswordConfirm: {
                    required: strLabelConfirmPassword,
                    equalTo: strLabelPasswordsDontMatch
                }
            }
        });

    return validator;
}

// Register
function FormValidateRegister(objForm) {
    var validator = $(objForm).validate(
        {
            rules: {
                // Check if e-mail doesn't exists (with a username)
                txtEmail: {
                    remote: {
                        url: strAjaxPath + 'validate/register-email.php',
                        type: 'post'
                    }
                },
                // Check if password is valid
                txtPassword: {
                    remote: {
                        url: strAjaxPath + 'validate/register-password.php',
                        type: 'post'
                    }
                },
                txtPasswordConfirm: {
                    equalTo: '#txtPassword'
                },
                // Check if vat number is valid
                txtVatnr: {
                    remote: {
                        url: strAjaxPath + 'validate/register-vat.php',
                        type: 'post',
                        data: {
                            txtVatpr: function () {
                                return $('#txtVatpr').val();
                            }
                        }
                    }
                }
            },
            // Error zipcode has to be shown after field 'city'
            errorPlacement: function (error, element) {
                if (element.attr('name') == 'txtZipcode') {
                    error.insertAfter('#txtCity');
                } else if (element.attr('name') == 'txtStreet') {
                    error.insertAfter('#txtAddressNumber');
                } else if (element.attr('name') == 'txtVatpr') {
                    error.insertAfter('#txtVatnr');
                } else if (element.attr('name') == 'chkConditions') {
                    error.insertAfter('#lblConditions');
                } else {
                    error.insertAfter(element);
                }
            },
            messages: {
                txtCompanyname: {
                    required: strLabelGiveCompanyname
                },
                txtVatpr: {
                    required: strLabelGiveVatPr
                },
                txtVatnr: {
                    required: strLabelGiveVatNr
                },
                txtFirstname: {
                    required: strLabelGiveFirstname
                },
                txtLastname: {
                    required: strLabelGiveLastname
                },
                txtStreet: {
                    required: strLabelGiveStreet
                },
                txtAddressNumber: {
                    required: strLabelGiveAddressNumber
                },
                txtZipcode: {
                    required: strLabelGiveZipcode
                },
                txtCity: {
                    required: strLabelGiveCity
                },
                txtPhone: {
                    required: strLabelGivePhone
                },
                txtEmail: {
                    required: strLabelGiveEmail,
                    customemail: strLabelEmailInvalid
                },
                txtUserName: {
                    required: strLabelGiveUsername
                },
                txtPassword: {
                    required: strLabelGivePassword
                },
                txtPasswordConfirm: {
                    required: strLabelConfirmPassword,
                    equalTo: strLabelPasswordsDontMatch
                }
            }
        });
    return validator;
}

// Edit address account data
function FormValidateAddressAccount(objForm) {
    var validator = $(objForm).validate(
        {
            rules: {
                // Check if e-mail doesn't already exists for another address
                txtEmail: {
                    remote: {
                        url: strAjaxPath + 'validate/address-email.php',
                        type: 'post'
                    }
                },
                // Check if the password is valid
                txtPassword: {
                    remote: {
                        url: strAjaxPath + 'validate/register-password.php',
                        type: 'post'
                    }
                },
                txtPasswordConfirm: {
                    equalTo: '#txtPassword'
                }
            },
            messages: {
                txtEmail: {
                    required: strLabelGiveEmail,
                    customemail: strLabelEmailInvalid
                },
                txtPasswordConfirm: {
                    equalTo: strLabelPasswordsDontMatch
                }
            }
        });

    return validator;
}


// Edit address data
function FormValidateAddressData(objForm) {
    var validator = $(objForm).validate(
        {
            rules: {
                // Check if vat number is valid
                txtVatnr: {
                    remote: {
                        url: strAjaxPath + 'validate/register-vat.php',
                        type: 'post',
                        data: {
                            txtVatpr: function () {
                                return $('#txtVatpr').val();
                            }
                        }
                    }
                }
            },
            // Error zipcode has to be shown after field 'city'
            errorPlacement: function (error, element) {
                if (element.attr('name') == 'txtZipcode') {
                    error.insertAfter('#txtCity');
                } else if (element.attr('name') == 'txtStreet') {
                    error.insertAfter('#txtAddressNumber');
                } else {
                    error.insertAfter(element);
                }
            },
            messages: {
                txtFirstname: {
                    required: strLabelGiveFirstname
                },
                txtLastname: {
                    required: strLabelGiveLastname
                },
                txtStreet: {
                    required: strLabelGiveStreet
                },
                txtAddressNumber: {
                    required: strLabelGiveAddressNumber
                },
                txtZipcode: {
                    required: strLabelGiveZipcode
                },
                txtCity: {
                    required: strLabelGiveCity
                },
                txtPhone: {
                    required: strLabelGivePhone
                }
            }
        });

    return validator;
}


// Add address to address book
function FormValidateAddAddress(objForm) {
    var validator = $(objForm).validate(
        {
            messages: {
                txtFirstname: {
                    required: strLabelGiveFirstname
                },
                txtLastname: {
                    required: strLabelGiveLastname
                },
                txtStreet: {
                    required: strLabelGiveStreet
                },
                txtAddressNumber: {
                    required: strLabelGiveAddressNumber
                },
                txtZipcode: {
                    required: strLabelGiveZipcode
                },
                txtCity: {
                    required: strLabelGiveCity
                }
            }
        });

    return validator;
}

// Edit address from address book
function FormValidateUpdateAddress(objForm) {
    var validator = $(objForm).validate(
        {
            messages: {
                txtFirstname: {
                    required: strLabelGiveFirstname
                },
                txtLastname: {
                    required: strLabelGiveLastname
                },
                txtStreet: {
                    required: strLabelGiveStreet
                },
                txtAddressNumber: {
                    required: strLabelGiveAddressNumber
                },
                txtZipcode: {
                    required: strLabelGiveZipcode
                },
                txtCity: {
                    required: strLabelGiveCity
                }
            }
        });

    return validator;
}


/**
 * Cart logged in
 * @param objForm
 * @param students
 * @returns {*|jQuery|undefined}
 * @constructor
 */
function FormValidateCartLoggedIn(objForm, students = false) {
    var validator = $(objForm).validate(
        {
            // Ignore has to be here, because then it shows also error messages if the form isn't visible
            ignore: [],
            // Error zipcode must be shown after field 'city'
            errorPlacement: function (error, element) {
                if (element.attr('name') == 'txtZipcode') {
                    error.insertAfter('#txtCity');
                } else if (element.attr('name') == 'txtStreet') {
                    error.insertAfter('#txtAddressNumber');
                } else {
                    console.log('element', element);
                    error.insertAfter(element);
                }
            },
            invalidHandler: function (event, validator) {
                // In step billing data in cart => show input fields (if needed)
                $('a#billing-modify').click();
            },
            messages: {
                txtFirstname: {
                    required: strLabelGiveFirstname
                },
                txtLastname: {
                    required: strLabelGiveLastname
                },
                txtStreet: {
                    required: strLabelGiveStreet
                },
                txtAddressNumber: {
                    required: strLabelGiveAddressNumber
                },
                txtZipcode: {
                    required: strLabelGiveZipcode
                },
                txtCity: {
                    required: strLabelGiveCity
                },
                txtPhone: {
                    required: strLabelGiveEmail
                },
                txtEmail: {
                    required: strLabelGiveEmail,
                    customemail: strLabelEmailInvalid
                }
            }
        });

    // Add validation rule for dynamically generated name fields (student input)
    if (students) {
        objForm.find('input.first-name').each(function () {
            $(this).rules('add',
                {
                    required: true,
                    messages: {
                        required: strLabelGiveFirstname
                    }
                });
        });

        objForm.find('input.last-name').each(function () {
            $(this).rules('add',
                {
                    required: true,
                    messages: {
                        required: strLabelGiveLastname
                    }
                });
        });

        objForm.find('input.phone').each(function () {
            $(this).rules('add',
                {
                    required: true,
                    messages: {
                        required: strLabelGivePhone
                    }
                });
        });
        objForm.find('input.email').each(function () {
            $(this).rules('add',
                {
                    required: true,
                    messages: {
                        required: strLabelGiveEmail,
                        email: strLabelEmailInvalid
                    }
                });
        });
    }

    return validator;
}

// Cart delivery - transport input (alternative delivery address)
function FormValidateCartTransportInput(objForm) {
    var validator = $(objForm).validate(
        {
            // Error zipcode must be shown after field 'city'
            errorPlacement: function (error, element) {
                if (element.attr('name') == 'txtTransportZipcode') {
                    error.insertAfter('#txtTransportCity');
                } else {
                    error.insertAfter(element);
                }
            },
            messages: {
                txtTransportFirstname: {
                    required: strLabelGiveFirstname
                },
                txtTransportLastname: {
                    required: strLabelGiveLastname
                },
                txtTransportAddress: {
                    required: strLabelGiveAddress
                },
                txtTransportZipcode: {
                    required: strLabelGiveZipcode
                },
                txtTransportCity: {
                    required: strLabelGiveCity
                }
            }
        });

    return validator;
}

// Gift card
function FormValidateGiftCard(objForm) {
    var validator = $(objForm).validate(
        {
            messages: {
                txtMessage: {
                    required: strLabelGiveMessage
                },
                txtName: {
                    required: strLabelGiveName
                },
                txtEmail: {
                    required: strLabelGiveEmail,
                    customemail: strLabelEmailInvalid
                },
                txtReceiverName: {
                    required: strLabelGiveNameReceiver
                },
                txtReceiverEmail: {
                    required: strLabelGiveEmailReceiver,
                    customemail: strLabelEmailReceiverInvalid
                }
            },
            submitHandler: function () {

                // Make a string from all input fields and make them begin with str, int
                var strGetParams = objForm.serialize();
                var strParams = strGetParams.replace(/&txt/g, '&str');
                strParams = strParams.replace('&hdnFormType', '&strFormType');
                strParams = strParams.replace(/&hdn/g, '&int');
                strParams = strParams.replace(/&opt/g, '&str');

                // Add giftcard to cart after the form is validated
                AddProductToCart(objForm, $('input#btnAddToCart'), false, false, strParams);
            }
        });

    return validator;
}

// Add a new wishlist
function FormValidateAddWishlist(objForm) {
    var validator = $(objForm).validate({
        ignore: [],
        errorPlacement: function (error, element) {
            if (element.attr('name') == 'txtTitle') {
                error.insertAfter('#btnAdd');
            } else if (element.is('input[type=\'hidden\']')) {
                error.appendTo(element.closest('li'));
            } else {
                error.insertAfter(element);
            }
        },
        messages: {
            txtTitle: {
                required: strLabelGiveTitle
            }
        },
        submitHandler: function () {
            $.post(strAjaxPath + 'wishlist/wishlist-add-list.php', objForm.serialize(), function (data) {
                if (data == 'OK') {
                    window.location.reload();
                }
            });
        }
    });
    return validator;
}

// CUSTOM: Ask an offer
function FormValidateOffer(objForm) {
    var validator = $(objForm).validate(
        {
            messages: {
                txtFirstname: {
                    required: strLabelGiveFirstname
                },
                txtLastname: {
                    required: strLabelGiveLastname
                },
                txtEmail: {
                    required: strLabelGiveEmail,
                    email: strLabelEmailInvalid,
                    customemail: strLabelEmailInvalid
                }
            },
            errorClass: 'text-danger mt-1'
        });

    return validator;
}

// CUSTOM: Send to a colleague
function FormValidateColleague(objForm) {
    var validator = $(objForm).validate(
        {
            messages: {
                txtFirstname: {
                    required: strLabelGiveFirstname
                },
                txtLastname: {
                    required: strLabelGiveLastname
                },
                txtEmail: {
                    required: strLabelGiveEmail,
                    email: strLabelEmailInvalid,
                    customemail: strLabelEmailInvalid
                },
                txtFirstnameColleague: {
                    required: strLabelGiveFirstnameColleague
                },
                txtLastnameColleague: {
                    required: strLabelGiveLastnameColleague
                },
                txtEmailColleague: {
                    required: strLabelGiveEmailColleague,
                    email: strLabelEmailInvalidColleague,
                    customemail: strLabelEmailInvalidColleague
                }
            },
            errorClass: 'text-danger mt-1'
        });

    return validator;
}

window.FormValidateAddWishlist = FormValidateAddWishlist;
window.FormValidateGiftCard = FormValidateGiftCard;
window.FormValidateCartTransportInput = FormValidateCartTransportInput;
window.FormValidateCartLoggedIn = FormValidateCartLoggedIn;
window.FormValidateUpdateAddress = FormValidateUpdateAddress;
window.FormValidateAddAddress = FormValidateAddAddress;
window.FormValidateAddressData = FormValidateAddressData;
window.FormValidateAddressAccount = FormValidateAddressAccount;
window.FormValidateRegister = FormValidateRegister;
window.FormValidateForgotPasswordReset = FormValidateForgotPasswordReset;
window.FormValidateForgotPassword = FormValidateForgotPassword;
window.FormValidateLogin = FormValidateLogin;
window.FormValidateUnsubscribe = FormValidateUnsubscribe;
window.FormValidateOffer = FormValidateOffer;
window.FormValidateColleague = FormValidateColleague;
